/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input, OnInit } from "@angular/core";
import { Merchant } from "../../../../models";
import { MerchantDetailsParentComponent } from "../../merchant-details-parent.component";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService, MerchantService, NotificationService, SharedFormService } from "../../../../services";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MERCHANT_CONSTANTS } from "../../../../utils/data.rest.constants";

@Component({
  selector: "app-wp-merchant-address",
  templateUrl: "./wp-merchant-address.component.html"
})
export class WpMerchantAddressComponent extends MerchantDetailsParentComponent implements OnInit {
  wpMerchantAddressForm!: FormGroup;
  editable = false;
  actionInProgress = false;
  hasRemit = false;
  buttonName = "Update Merchant Address";
  @Input("merchant") merchant!: Merchant;

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    merchantService: MerchantService,
    notificationService: NotificationService,
    authService: AuthService,
    private fb: FormBuilder,
    private sharedFormService: SharedFormService
  ) {
    super(router, activatedRoute, merchantService, notificationService, authService);
  }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.wpMerchantAddressForm = this.fb.group({
      merchantAddress: this.sharedFormService.getMerchantAddressFormGroup(this.merchant),
      remitToAddress: this.sharedFormService.getRemitAddressFormGroup(this.merchant)
    });
    if (this.merchant.remitToAddress === null) {
      this.wpMerchantAddressForm.controls["remitToAddress"].get("address1")?.removeValidators([Validators.required]);
      this.wpMerchantAddressForm.controls["remitToAddress"].get("city")?.removeValidators([Validators.required]);
      this.wpMerchantAddressForm.controls["remitToAddress"].get("state")?.removeValidators([Validators.required]);
      this.wpMerchantAddressForm.controls["remitToAddress"].get("zip")?.removeValidators([Validators.required]);
      this.wpMerchantAddressForm.controls["remitToAddress"].get("country")?.removeValidators([Validators.required]);
    }
  }

  setEditable(value: boolean) {
    this.editable = value;
  }

  updateMerchantAddress(): void {
    if (this.wpMerchantAddressForm.valid) {
      this.actionInProgress = true;
      this.setFeeDetailsToNullIfNoneExist(this.merchant);
      const tempMerchant = JSON.parse(JSON.stringify(this.merchant));
      if (!this.hasRemit) {
        this.sharedFormService.updateMerchantAddress(tempMerchant, this.merchantAddressFormGroup);
      } else {
        this.sharedFormService.updateMerchantAddress(
          tempMerchant,
          this.merchantAddressFormGroup,
          this.remitAddressFormGroup
        );
      }
      tempMerchant.statementOptions = {};
      if (!this.authService.getUserRole(MERCHANT_CONSTANTS.FINANCE)) {
        tempMerchant.contractedRates = null as any;
      }
      this.merchantService.updateElementMerchant("ADDRESS", tempMerchant).subscribe(
        (merchant) => {
          this.merchant = merchant;
          this.editable = false;
          this.actionInProgress = false;
        },
        (error) => {
          this.notificationService.error(error.error);
          this.actionInProgress = false;
        }
      );
    } else {
      this.wpMerchantAddressForm.markAllAsTouched();
    }
  }

  receiveEditEvent(value: boolean) {
    this.editable = value;
    this.createForm();
  }

  get merchantAddressFormGroup(): FormGroup {
    return this.wpMerchantAddressForm.controls["merchantAddress"] as FormGroup;
  }

  get remitAddressFormGroup(): FormGroup {
    return this.wpMerchantAddressForm.controls["remitToAddress"] as FormGroup;
  }

  hasRemitEvent(hasRemitEvent: boolean) {
    this.hasRemit = hasRemitEvent;
  }
}
